module.exports = __webpack_public_path__ + "img/suggestDo.8ebb3b91.svg";